import moment from 'moment-timezone';
import 'moment/locale/es';

moment.locale('es');

export const parseDateTime = (date: Date): string => {
  return moment(date).format('DD [de] MMMM HH:mm');
};

export const parseDateTimeLumen = (date: Date, venueTimeZone?: string): string => {
  if (venueTimeZone) {
    return moment(date).tz(venueTimeZone).format('yyyy-MM-DD HH:mm:ss');
  } else {
    return moment(date).format('yyyy-MM-DD HH:mm:ss');
  }
};

export const parseDateToFormik = (date: Date, venueTimeZone?: string): string => {
  if (venueTimeZone) {
    return moment(date).tz(venueTimeZone).format('yyyy-MM-DD[T]HH:mm');
  } else {
    return moment(date).format('yyyy-MM-DD[T]HH:mm');
  }
};

export function formatDateTime(date: string): string {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${day}/${month} ${hours}:${minutes}`;
}
